export default class ScorecardDetailsViewModel {
    public client: string = '';
    public channel: string = '';
    public name: string = '';
    public scorecardType: string = '';
    public passThreshold: number | null = null;
    public resQPassThreshold: number | null = null;
    public customerLevel: boolean = false;
    public deleteOnChallengeUpheld: boolean = false;
    public enableLevelling: boolean = false;
    public enableCalibration: boolean = false;
    public enableQACopy: boolean = false;
    public hasBeenActive: boolean = false;
}